import gql from 'graphql-tag';

export default gql`
    query ($coin: String!) {
        getNetworkFee(coin: $coin)
    }
`;